<template>
  <div class="dw">
    <div v-if="loading && !publishing" class="dw-skeleton"></div>
    <p v-else-if="!items.length" class="ov-empty">{{ $t('dash.overview.activity.no_posts') }}</p>
    <MiniDonut v-else :items="items" />
  </div>
</template>

<script>
import MiniDonut from './MiniDonut.vue'

/**
 * Publications de la période réparties par réseau (tous réseaux, via la solution)
 */
export default {
  name: 'DistributionWidget',

  components: { MiniDonut },

  props: {
    publishing: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  },

  computed: {
    items() {
      return Object.entries((this.publishing && this.publishing.by_network) || {})
        .map(([network, value]) => ({ label: this.$t(`dash.overview.network.${network}`), value }))
    }
  }
}
</script>

<style scoped>
.dw {
  height: 100%;
  min-height: 0;
}
.dw-skeleton {
  height: 100%;
  border-radius: 6px;
  background: #f1edf5;
}
</style>
